import $ from 'jquery';
import { SCENE_INTERACTION } from '../../../constants/scene';
import { TextureLoader } from 'three';
import { ICON } from "../../Icons/Icons";

const getCustomLogo = (customLogo) => (customLogo && customLogo !== './textures/empty.png' ? customLogo : null);

const template = (data) => `
<div class="modal edit_profile_holder userProfileModal" id="userProfileModal">
  <div class="modal-background"></div>
  ${getCustomLogo(data.customLogo) ? `<div class="modal-background-logo"><img alt="Logo" src="${getCustomLogo(data.customLogo)}" /></div>` : ''}
  
  <div class="modal-content">
    <button class="close-modal" id="close-edit-profile">
      ${ICON.CLOSE}
    </button>
    
    <section id="user-profile-modal-content" class="profile">
      <div class="profile-header">
        <div class="profile-header--avatar">
          <img src="${data.avatar_image_url}" onerror="this.src='/textures/defaultAvatar.png'" alt="User Avatar" />
        </div>
        <div class="profile-header--info">
          <h2 class="username">${data.username || ""}</h2>
          <div id="user-mood" class="status">Available</div>
          <div class="mt-3">
            <button id='edit-data-image-user-profile'>${ICON.PENCIL}</button>
          </div>
        </div>
      </div>
      
      <div class="profile-details">
        <div class="profile-item">
          <div class="profile-item--icon">
            ${ICON.MAP_PIN}
          </div>
          <div class="profile-item--content">
            <label>Location</label>
            <span>${data.city || ""}</span>
          </div>
        </div>
        
        <div class="profile-item">
          <div class="profile-item--icon">
            ${ICON.INTERESTS}
          </div>
          <div class="profile-item--content">
            <label>Interests</label>
            <span>${data.interests || ""}</span>
          </div>
        </div>
        
        <div class="profile-item">
          <div class="profile-item--icon">
            ${ICON.MAP_PIN}
          </div>
          <div class="profile-item--content">
            <label>User plan</label>
            <span>${data.subscription?.name || "Free"}</span>
          </div>
        </div>
      </div>
      <!--
      <div class="profile-footer">
        <button class="button primary" id="upgrade-to-premium">Upgrade to Premium</button>
      </div>
      -->
    </section>
  </div>
</div>
`;

const template_edit = (data) => `
<div class="modal edit_profile_holder userEditProfileModal" id="userProfileModal">
  <div class="modal-background"></div>
  
  <div class="modal-content">
    <button class="close-modal" id="close-edit-profile">
      ${ICON.CLOSE}
    </button>
    <section id="user-profile-modal-content">
      <div class="big-wrapper">
        <div class="profile-card">
          <div class="profile-header">
            <div class="profile-image-wrapper">
              <div class="profile-user-image">
                <img id="profile-modal-user-image" src="${data.avatar_image_url}" onerror="this.src='/textures/defaultAvatar.png'" alt="User Avatar" />
              </div>
              <button id="upload-image-user-profile">${ICON.UPLOAD}</button>
            </div >
          </div >
          
          <div class="profile-form">
            <div class="profile-form-row">
              <div class="profile-form-column">
                <div class="profile-form-group">
                  <label for="userName">${ICON.PEOPLE_ONE}</label>
                  <input name="userName" id="userName" class="profile-form-input" type="text" value="${data.username || ""}" placeholder="Username">
                </div>
                <div class="profile-form-group">
                  <label for="location">${ICON.MAP_PIN}</label>
                  <input name="location" id="location" class="profile-form-input" type="text" value="${data.city || ""}" placeholder="Lagos">
                </div>
                <div class="profile-form-group">
                  <label for="interests">${ICON.INTERESTS}</label>
                  <input name="interests" id="interests" class="profile-form-input" type="text" value="${data.interests || ""}" placeholder="Jiu Jitsu, Paragliding, Travelling">
                </div>
              </div>
              
              <div class="profile-form-column">
                <div class="profile-form-group">
                  <label for="website">
                    ${ICON.URL}
                  </label>
                  <input name="website" id="website" class="profile-form-input" type="text" value="${data.web || ""}" placeholder="bagless.io">
                </div>
              </div>
            </div>
          </div>
          
          <div class="profile-footer">
            <button id="my-profile-save-button" class="button primary w-full">Save changes</button>
            <button id="my-profile-cancel-button" class="button cancel w-full">Cancel</button>
          </div>
        </div >
      </div >
    </section >
  </div >
</div >
  `;

const template_profile = (data) => `
<div class="modal user_profile_holder userEditProfileModal light-theme" id="userProfileModal">
  <div class="modal-background"></div>
  
  <div class="modal-content non-fullscreen-mobile">
    <section id="user-profile-modal-content">
      <div class="big-wrapper">
        <div class="profile-card">
          <div class="profile-header align-items-start">
            <h2 class="profile-card-title mb-4">Edit Profile Information</h2>
          </div >
          
          <div class="profile-form">
            <div class="profile-form-row">
              <div class="profile-form-column">
                <div class="profile-form-group">
                  <label for="userName">${ICON.PEOPLE_ONE}</label>
                  <input name="userName" id="userName" class="profile-form-input" type="text" value="${data.username || ""}" placeholder="Username">
                </div>
                <div class="profile-form-group">
                  <label for="location">${ICON.MAP_PIN}</label>
                  <input name="location" id="location" class="profile-form-input" type="text" value="${data.city || ""}" placeholder="Lagos">
                </div>
                <div class="profile-form-group">
                  <label for="interests">${ICON.INTERESTS}</label>
                  <input name="interests" id="interests" class="profile-form-input" type="text" value="${data.interests || ""}" placeholder="Jiu Jitsu, Paragliding, Travelling">
                </div>
              </div>
            </div>
          </div>
          
          <div class="profile-footer">
            <button id="my-profile-save-button" class="button primary w-full">Save changes</button>
            <button id="my-profile-cancel-button" class="button cancel w-full">Cancel</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
`;

class UserProfileModal {
  constructor({ model, isEditMode = false, isProfilePage = false, isSpaceBrowser = false }) {
    this.model = model;
    this.isProfilePage = isProfilePage;
    this.isSpaceBrowser = isSpaceBrowser;
    this.isEditMode = isEditMode;
    this.info = {
      room: this.model.sceneData.name || this.model.sceneData.publicName,
      customLogo: this.model.sceneData.customLogo,
    };
    this.toggleModeButton;
    this.textureLoaderSilent = new TextureLoader();
    this.createContainer();
    this.initEvents();
    this.replaceExistingModal();
    this.loadData();
    this.model.addEventListener(SCENE_INTERACTION.USER_MOOD_CHANGED, (payload) => {
      this.userMood(payload.data.mood);
    });
    this.model.addEventListener(SCENE_INTERACTION.USER_AVATAR_CHANGED, (payload) => {
      this.loadData();
    });
  }

  loadData() {
    this.model.worldFetcher.getProfileInfo(this.model.config.userId,
      (response) => {
        this.info = { ...this.info, ...response.data, customLogo: this.model.sceneData.customLogo };
        this.createContainer();
        this.initEvents();
        this.updateUI();
      });
  }

  createContainer() {
    switch (true) {
      case this.isProfilePage:
        this.container = $(template_profile(this.info));
        break;
      case this.isEditMode:
        this.container = $(template_edit(this.info));
        break;
      case !this.isEditMode:
        this.container = $(template(this.info));
        break;
    }
    this.replaceExistingModal();
  }

  initEvents() {
    this.toggleModeButton = this.container.find('#edit-data-image-user-profile');
    this.toggleModeButton.on('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.toggleMode();
    });

    this.closeButton = this.container.find('.close-modal').on("click", () => {
      this.container.removeClass("is-active");
      this.isEditMode = false;
      this.createContainer();
      $('#userProfileModal').replaceWith(this.container);
      this.initEvents();
    });

    this.deviceSettings1 = this.container.find('#profile-device-settings').on("click", () => {
      this.container.removeClass("is-active");
      this.isEditMode = false;
      this.createContainer();
      $('#userProfileModal').replaceWith(this.container);
      this.initEvents();
      $("#mediaSettings").trigger("click");
    });

    this.deviceSettings2 = this.container.find('#profile-device-settings2').on("click", () => {
      this.container.removeClass("is-active");
      this.isEditMode = false;
      this.createContainer();
      $('#userProfileModal').replaceWith(this.container);
      this.initEvents();
      $("#mediaSettings").trigger("click");
    });

    this.deviceSettings3 = this.container.find('#profile-device-settings3').on("click", () => {
      this.container.removeClass("is-active");
      this.isEditMode = false;
      this.createContainer();
      $('#userProfileModal').replaceWith(this.container);
      this.initEvents();
      $("#mediaSettings").trigger("click");
    });

    this.deviceSettings4 = this.container.find('#profile-device-settings4').on("click", () => {
      this.container.removeClass("is-active");
      this.isEditMode = false;
      this.createContainer();
      $('#userProfileModal').replaceWith(this.container);
      this.initEvents();
      $("#mediaSettings").trigger("click");
    });

    this.container.find('#my-profile-cancel-button').on("click", () => {
      this.container.removeClass("is-active");
      this.isEditMode = false;
      this.createContainer();
      $('#userProfileModal').replaceWith(this.container);
      this.initEvents();
    });

    this.saveButton = this.container.find('#my-profile-save-button').on("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.isEditMode = false;

      const userId = this.model.config.userId;
      const userName = $('#userProfileModal input[name=userName]').val();
      const company = $('#userProfileModal input[name=company]').val();
      const location = $('#userProfileModal input[name=location]').val();
      const website = $('#userProfileModal input[name=website]').val();
      const interests = $('#userProfileModal input[name=interests]').val();
      let userAvatarUrl;
      let data = {};
      this.container.removeClass("is-active");

      userAvatarUrl = $('#userProfileModal img').attr('src');
      data = {
        userId,
        ...(
          this.isProfilePage
            ? { userName, location, interests }
            : { userAvatarUrl, userName, company, location, website, interests }
        ),
      };

      this.model.saveProfile({ url: this.model.config.saveProfileUrl, data }, () => {
        this.model.info('success', $trans('user-profile-text-saved'));
        this.loadData();
      });

      this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_AVATAR_CHANGED, data });

      this.createContainer();
      $('#userProfileModal').replaceWith(this.container);
      this.initEvents();
      this.model.userAvatarTexture = this.textureLoaderSilent.load(data.userAvatarUrl);
      $('#username').html(userName);
    });

    // Initialize input change events
    this.initInputChangeListeners();
    if (!this.isSpaceBrowser) {
      this.model.uploadImage('#upload-image-user-profile', true, this.model.config.temporaryFileUploadUrl, 'avatar', false, this.model.config.addImageUrl, this.userAvatarUploadImageCallback, { aspectRatio: 1, width: 256, height: 256 });
    }

    if (!this.isProfilePage && !this.isSpaceBrowser) {
      this.userMood(this.model.socket.getUserData().currentUserMood);
    }
  }

  initInputChangeListeners() {
    const inputs = this.container.find('input[type="text"]');
    const saveButton = this.container.find('#my-profile-save-button');
    const errorMessage = this.container.find('.error-message');
    inputs.on('input', (e) => {
      const userName = this.container.find('input[name="userName"]').val();
      let errorText = '';

      if (!this.isUsernameValid(userName)) {
        errorText = 'Username cannot contain spaces.';
      } else if (userName.length < 3) {
        errorText = 'Username must be at least 3 characters long.';
      }

      if (errorText) {
        saveButton.addClass('disabled');
        errorMessage.text(errorText).show();
      } else {
        saveButton.removeClass('disabled');
        errorMessage.hide();
      }
    });

    // Disable the save buttons initially
    saveButton.addClass('disabled');
  }

  isUsernameValid(username) {
    // Check if the username does not contain spaces
    return /^[^\s]+$/.test(username);
  }

  toggleMode() {
    this.isEditMode = !this.isEditMode;
    this.rerenderContainer();
  }

  rerenderContainer() {
    this.createContainer();
    this.container.addClass("is-active");
    this.initEvents();
  }

  replaceExistingModal() {
    const existingModal = $('#userProfileModal');
    if (existingModal.length) {
      existingModal.replaceWith(this.container);
    } else {
      $('body').append(this.container);
    }
  }
  userAvatarUploadImageCallback = (url) => {
    const saveButton = this.container.find('#my-profile-save-button');
    saveButton.removeClass('disabled');
    $('#chosen-avatar').attr('src', this.model.config.baseWebUrl + url);
    $('#profile-modal-user-image').attr('src', this.model.config.baseWebUrl + url);
    this.model.config.userAvatarUrl = this.model.config.baseWebUrl + url
    this.container.addClass("is-active");
  }

  updateUI() {
    if (this.model.config.userAvatarUrl.includes(this.model.config.baseWebUrl)) {
      $('#navbar-user-menu img.local-avatar').attr('src', this.model.config.userAvatarUrl);
    } else {
      $('#navbar-user-menu img.local-avatar').attr('src', this.model.config.baseWebUrl + this.model.config.userAvatarUrl);
    }
  }

  userMood = (mood) => {
    const txtMod = this.model.getUserMood(mood);
    const userMood = this.container.find('#user-mood');
    userMood.text(txtMod.name).removeClass('is-primary is-warning is-danger').addClass(txtMod.color);
  }

  render() {
    return this.container[0];
  }
}

export default UserProfileModal;
